// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2QnUW","clinicsSelect":"TableHeading_clinicsSelect__3TXvU"};